var modSubscriptions = function(){
    var scope = ".js-mod-subscriptions";
    ui.ready(
        scope,
        function($mod){
            $mod.find("[name=shop_subscription_type_id]").on("change",function(event){
                event.preventDefault();
                var shopSubscriptionTypeId = $mod.find("[name=shop_subscription_type_id]:checked").val();
                gvf.endpoint(
                    "web\\shopProcessController::applySubscriptionDiscount",
                    [shopSubscriptionTypeId],
                    function(response){
                        if(response && response.messsages && response.messsages.length>0){
                            utils.alertEndpointResponse(response);
                        }

                        modCartDetail.updateCartContents();
                        modCartDetail.getCartDetail();
                    }
                );
            })

        }
    );

}();